export default __webpack_public_path__ + "static/media/pileofgold1.eac72451.png";